module.exports = __webpack_public_path__ + "img/icon_home_ai_icon_12.5678b55e.png";